// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60333863","239":"c756256e","455":"e1e8a145"}[chunkId] + ".chunk.js";
};